import React from 'react'
import { FormProvider,SubmitHandler, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { loginSchema } from 'schemas/loginSchema'
import { useAppDispatch } from 'store'
import styled from 'styled-components'

import santaCat from 'assets/logo_santa.png'
import logoColor from 'assets/logoColor.png'
import welcomeCat from 'assets/welcomeCat.png'
import { Button } from 'components/atoms/Button'
import { InputF } from 'components/atoms/Form/InputF'
import { useFeatureFlag } from 'hooks/useFeatureFlag'
// import { CheckboxF } from 'components/atoms/Form/CheckboxF'
import { useYupValidationResolver } from 'hooks/useYupValidationResolver'
import { DEFAULT_PAGINATION } from 'pages/components/Menu'
import { getProfile, login } from 'services/authSlice'
import { KEYS, localStorageService } from 'utils/localStorage'
import { PATHS } from 'utils/paths'

type FormFields = {
  email: string
  password: string
  rememberMe: boolean
}

const LoginPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const isLandingPagesEnabled = useFeatureFlag('landingPages')
  const resolver = useYupValidationResolver(loginSchema)
  const methods = useForm<FormFields>({
    resolver
    // mode: 'onBlur'
  })

  const {
    handleSubmit,
    formState: { isSubmitting }
  } = methods

  const onSubmit: SubmitHandler<FormFields> = async (
    data: FormFields,
    e: any
  ) => {
    e.preventDefault()
    const action = await dispatch(login(data))

    if (action.meta.requestStatus === 'fulfilled') {
      const profileAction = await dispatch(getProfile())

      if (profileAction.meta.requestStatus !== 'fulfilled') {
        return
      }

      const storedMenuMode = localStorageService.get(KEYS.menuMode)
      const defaultPath =
        isLandingPagesEnabled && storedMenuMode === 'landing-pages'
          ? `${PATHS.landingPages}?country=${action.payload.defaultCountry}&size=${DEFAULT_PAGINATION.size}&page=${DEFAULT_PAGINATION.page}&brand=All`
          : `${PATHS.products}?country=${action.payload.defaultCountry}&size=${DEFAULT_PAGINATION.size}&page=${DEFAULT_PAGINATION.page}&brand=All`

      return navigate(`${PATHS.policyAcceptance}`, {
        state: {
          path: defaultPath
        }
      })
    }
  }

  const navigateToResetPassword = () => {
    return navigate(PATHS.resetPassword)
  }

  const navigateToLogin = () => {
    return navigate(PATHS.login)
  }

  return (
    <Wrapper>
      <LogoWrapper onClick={navigateToLogin}>
        <Logo src={logoColor} alt='logo' />
      </LogoWrapper>
      <FormProvider {...methods}>
        <WelcomeImageWrapper>
          <WelcomeImage src={welcomeCat} alt='logo' />
        </WelcomeImageWrapper>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <InputF name='email' label='Email' type='text' size='large' />
          <InputF
            name='password'
            label='Password'
            type='password'
            size='large'
          />
          {/* <CheckboxF name='rememberMe' label='zapamietaj mnie' /> */}
          <ReserPassword type='button' onClick={navigateToResetPassword}>
            Reset password
          </ReserPassword>
          <Button
            variant='primary'
            size='large'
            type='submit'
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            Login
          </Button>
        </Form>
      </FormProvider>
      <Copyright>
        <span>&#169; SINDYCAT</span>
      </Copyright>      
      <BottomLine />
    </Wrapper>
  )
}

export default LoginPage

const Wrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
const Form = styled.form`
  width: 516px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`
const ReserPassword = styled.button`
  border: 0;
  padding: 0;
  margin-bottom: 10px;
  background-color: unset;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
`
const Copyright = styled.div`
  position: absolute;
  bottom: 60px;
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 32px;
  left: 32px;
`
const Logo = styled.img`
  height: ${({ theme }) => theme.dimensions.logoColorHeight + 'px'};
`

const WelcomeImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -162px;
`
const WelcomeImage = styled.img`
  height: 182px;
`
const BottomLine = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 24px;
  background: ${({ theme }) => theme.gradients.bottomLine};
`
